import { generateMeta } from '~/utils/generateMeta';

import LoginView from './View';

export { action } from './action.server';
export { loader } from './loader.server';

export const meta = generateMeta({
  title: 'Login',
  extraMetaTags: [
    { name: 'description', content: 'Login to use the administration tools' },
  ],
});

export default function Login() {
  return <LoginView />;
}
